/* Prime Soles theme — cart drawer, variant picker, gallery, drawers. Uses Shopify's Ajax Cart API. */
(function () {
  const R = window.PrimeSoles.routes;
  const $ = (s, c = document) => c.querySelector(s);
  const $$ = (s, c = document) => Array.from(c.querySelectorAll(s));

  /* Drawers */
  function openDrawer(id) {
    const d = document.getElementById(id); if (!d) return;
    d.classList.add('is-open'); d.setAttribute('aria-hidden', 'false'); document.body.classList.add('no-scroll');
    const f = d.querySelector('button, a, input'); f && f.focus();
  }
  function closeDrawer(d) { d.classList.remove('is-open'); d.setAttribute('aria-hidden', 'true'); document.body.classList.remove('no-scroll'); }
  document.addEventListener('click', (e) => {
    const o = e.target.closest('[data-open-drawer]');
    if (o) { e.preventDefault(); openDrawer(o.dataset.openDrawer); return; }
    const c = e.target.closest('[data-close-drawer]');
    if (c) { e.preventDefault(); closeDrawer(c.closest('.drawer')); }
  });
  document.addEventListener('keydown', (e) => { if (e.key === 'Escape') $$('.drawer.is-open').forEach(closeDrawer); });

  /* Search toggle */
  document.addEventListener('click', (e) => {
    const t = e.target.closest('[data-search-toggle]'); if (!t) return;
    e.preventDefault(); const s = $('#HeaderSearch'); s.classList.toggle('is-open');
    if (s.classList.contains('is-open')) $('input', s).focus();
  });

  /* Cart */
  async function refreshCart(open) {
    const res = await fetch(`${R.root}?sections=cart-drawer-content`.replace('//?', '/?'));
    const data = await res.json();
    const html = new DOMParser().parseFromString(data['cart-drawer-content'], 'text/html');
    const fresh = html.querySelector('#CartDrawerInner'); const cur = $('#CartDrawerInner');
    if (fresh && cur) cur.replaceWith(fresh);
    const count = fresh ? fresh.dataset.count : '0';
    $$('[data-cart-count]').forEach((el) => { el.textContent = count; el.dataset.count = count; });
    if (open) openDrawer('CartDrawer');
  }
  async function addToCart(form, btn) {
    const label = btn.innerHTML; btn.disabled = true; btn.textContent = 'Adding…';
    const err = form.querySelector('[data-form-error]'); if (err) err.textContent = '';
    try {
      const res = await fetch(R.cart_add + '.js', { method: 'POST', headers: { Accept: 'application/json' }, body: new FormData(form) });
      const json = await res.json();
      if (!res.ok) throw new Error(json.description || json.message || 'Could not add to bag');
      if (window.PrimeSoles.cartType === 'page') { window.location = R.cart; return; }
      await refreshCart(true);
    } catch (e) { if (err) err.textContent = e.message; else alert(e.message); }
    finally { btn.disabled = false; btn.innerHTML = label; }
  }
  document.addEventListener('submit', (e) => {
    const form = e.target.closest('form[data-product-form]'); if (!form) return;
    e.preventDefault(); addToCart(form, form.querySelector('[type=submit]'));
  });
  async function changeLine(key, quantity) {
    const inner = $('#CartDrawerInner'); inner && inner.classList.add('is-loading');
    await fetch(R.cart_change + '.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ id: key, quantity }) });
    if ($('[data-cart-page]')) { window.location.reload(); return; }
    await refreshCart(false);
  }
  document.addEventListener('click', (e) => {
    const b = e.target.closest('[data-line-change]'); if (!b) return;
    e.preventDefault(); changeLine(b.dataset.key, parseInt(b.dataset.qty, 10));
  });

  /* Product page: variant picker */
  $$('[data-product]').forEach((root) => {
    const variants = JSON.parse($('[data-variants]', root).textContent);
    const form = $('form[data-product-form]', root);
    const idInput = $('input[name=id]', form);
    const btn = $('[data-add-btn]', root);
    const priceEl = $('[data-price]', root);
    const stockEl = $('[data-stock]', root);
    const money = (c) => (window.Shopify && Shopify.formatMoney) ? Shopify.formatMoney(c) : root.dataset.currency + ' ' + (c / 100).toFixed(2);
    const selected = () => $$('fieldset.option', root).map((f) => ($('input:checked', f) || {}).value);
    function markAvailability() {
      const sel = selected();
      $$('fieldset.option', root).forEach((f, i) => {
        $$('input', f).forEach((inp) => {
          const test = sel.slice(); test[i] = inp.value;
          const ok = variants.some((v) => v.available && v.options.every((o, j) => o === test[j]));
          inp.nextElementSibling.classList.toggle('is-unavailable', !ok);
        });
      });
    }
    function update() {
      const sel = selected();
      const v = variants.find((x) => x.options.every((o, i) => o === sel[i]));
      markAvailability();
      if (!v) { btn.disabled = true; btn.textContent = 'Unavailable'; return; }
      idInput.value = v.id;
      btn.disabled = !v.available; btn.textContent = v.available ? 'Add to bag' : 'Sold out';
      if (stockEl) { stockEl.textContent = v.available ? 'In stock — ready to ship' : 'This size is sold out'; stockEl.classList.toggle('is-out', !v.available); }
      if (priceEl) {
        const sale = v.compare_at_price && v.compare_at_price > v.price;
        priceEl.classList.toggle('price--sale', !!sale);
        priceEl.innerHTML = `<span class="price__now">${money(v.price)}</span>${sale ? `<s>${money(v.compare_at_price)}</s>` : ''}`;
      }
      const url = new URL(window.location); url.searchParams.set('variant', v.id); history.replaceState(null, '', url);
      if (v.featured_media) {
        const slide = root.querySelector(`[data-media-id="${v.featured_media.id}"]`);
        slide && slide.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'start' });
      }
    }
    root.addEventListener('change', (e) => { if (e.target.closest('fieldset.option')) update(); });
    markAvailability();

    const q = $('[data-qty] input', root);
    root.addEventListener('click', (e) => {
      const s = e.target.closest('[data-qty-step]'); if (!s || !q) return;
      q.value = Math.max(1, (parseInt(q.value, 10) || 1) + parseInt(s.dataset.qtyStep, 10));
    });

    /* Gallery thumbs + lightbox */
    const main = $('.gallery-main', root);
    $$('.thumbs button', root).forEach((t, i) => t.addEventListener('click', () => {
      main.scrollTo({ left: main.clientWidth * i, behavior: 'smooth' });
    }));
    if (main) main.addEventListener('scroll', () => {
      const i = Math.round(main.scrollLeft / main.clientWidth);
      $$('.thumbs button', root).forEach((t, j) => t.setAttribute('aria-current', i === j));
    }, { passive: true });
    const lb = $('#Lightbox');
    $$('.gallery-main img', root).forEach((img) => img.addEventListener('click', () => {
      $('img', lb).src = img.dataset.zoom || img.src; $('img', lb).alt = img.alt; lb.classList.add('is-open');
    }));
    lb && lb.addEventListener('click', () => lb.classList.remove('is-open'));
  });

  /* Collection: filters + sort submit */
  $$('[data-filter-form]').forEach((f) => f.addEventListener('change', (e) => {
    if (e.target.type === 'number') return; f.submit();
  }));
  document.addEventListener('click', (e) => {
    const t = e.target.closest('[data-filters-toggle]'); if (!t) return;
    $('#Filters').classList.toggle('is-open');
  });
})();
